import {createApi} from '@reduxjs/toolkit/query/react'
import {fetchBaseFPNetQuery} from "@commons/utils/fetchBaseFPNetQuery";
import {addURI, transformResponse} from "@commons/utils/APIParams";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {config} from "@commons/config.instance";


/*function onQueryStarted(
    arg: any,
    api: QueryLifecycleApi<any, any, any, any>
): Promise<void> | void {
    try {
        // @ts-ignore
        const {meta} = await api.queryFulfilled
        // `onSuccess` side-effect
        if (meta && meta.response) {
            const tokenExpires = meta.response.headers.get('session-end');
            if (tokenExpires) {
                console.log(tokenExpires)
                api.dispatch(refreshSuccess(tokenExpires));
            }
        }
    } catch (err) {
    }
}*/

export const aziendaGeneralitaApi = createApi({
    reducerPath: 'aziendaGeneralitaApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('FPNet')}),
    endpoints: (builder) => ({

        //https://fpnet2.ericed.it/FPNet2021/azienda/1?auth_token=b5044e4af1a7aa6778467920f255f27a&nowId=1671464039611&idAziendaMaster=1
        getAzienda: builder.query<AziendaRecord, { idAzienda: number }>({
            query: ({idAzienda}) => {

                return `/azienda/${idAzienda}`;
            },
            transformResponse: addURI,
            //onQueryStarted:async onQueryStarted,
            /*async onQueryStarted(id, {dispatch, queryFulfilled}) {
                try {
                    const {meta} = await queryFulfilled
                    // `onSuccess` side-effect
                    if (meta && meta.response) {
                        const tokenExpires = meta.response.headers.get('session-end');
                        if (tokenExpires) {
                            console.log(tokenExpires)
                            dispatch(refreshSuccess(tokenExpires));
                        }
                    }
                } catch (err) {
                }
            },*/
        }),

        updateAzienda: builder.mutation<Partial<AziendaRecord>, Partial<AziendaRecord> & Pick<AziendaRecord, 'URI'>>({
            // note: an optional `queryFn` may be used in place of `query`
            query: ({URI, ...patch}) => ({
                url: URI ? URI : '',
                method: 'PATCH',
                body: patch,
            }),
            transformResponse
        }),

    }),
})
export const {
    useGetAziendaQuery, useLazyGetAziendaQuery, useUpdateAziendaMutation
} = aziendaGeneralitaApi;